module.exports = __webpack_public_path__ + "assets/settings_icon.16225cb6.svg";